export default {
    content_plural: "Contents",
    content: "Contents",
    finished: "Finished",
    how_do_you_rate_this_trail: "How do you rate this track?",
    loading_trails: "Loading trails",
    no_trails_are_available_at_the_moment: "There are currently no trails available",
    no_trails_are_available_with_the_selected_filter: "There are no trails available for the selected filter",
    only_available_when_finished_trail: "Available only after the trail is completed"
}